export default __webpack_public_path__ + "images/19a0be28ed1e0d7cfc51825ba0315fdc-nightlife_shadow.svg";